import { rbcInsuranceApi } from "@b2bportal/rbc-insurance-api";
import { ParentState } from "@checkout/index";
import { getPriceQuoteCipherText } from "@checkout/states/Cart/CartQuote/selectors";
import axios from "axios";
import type { ParentContextWithTripInsurance } from "../context";
import type { TripInsuranceProductsResponse } from "../types";

export const fetchTripInsuranceProductsService = async (
  context: ParentContextWithTripInsurance,
  _event: unknown
) => {
  const cipherText = getPriceQuoteCipherText({ context });

  const provinceCode = context[ParentState.insurance].provinceCode;
  const response = await rbcInsuranceApi(axios).apiV0RbcInsuranceProductsPost({
    quoteId: cipherText,
    provinceCode,
  });
  return {
    ...response.data,
    provinceCode,
  } satisfies TripInsuranceProductsResponse;
};
